module.exports = __webpack_public_path__ + "media/svg-new/rank1-582a98c3.svg";